'use client'
import { faq } from '@/app/(home)/data'
import { Accordion, Heading, Section } from '@/components'
import { usePartner } from '@/hooks'

const Faq = () => {
  const { getStoredPartner } = usePartner()

  const storedPartner = getStoredPartner()
  const faqData = faq(storedPartner)
  return (
    <Section id="faq">
      <Heading subtitle="Perguntas Frequentes">FAQ</Heading>

      <div className="mx-auto w-full max-w-3xl">
        {faqData.map((item, i) => (
          <Accordion open={i === 0} key={i} title={item.title} content={item.content} />
        ))}
      </div>
    </Section>
  )
}

export default Faq
